const WIDGET_LOADER_URL = 'https://www.ppl.cz/accesspointwidget/loader.js';
const LEGACY_CSS_URL = 'https://www.ppl.cz/sources/map/main.css';
const LEGACY_JS_URL = 'https://www.ppl.cz/sources/map/main.js';

export default class PplParcelShopSelector {

    constructor(selector) {
        this.selector = selector;
        this.currentModal = null;
        this.widgetElement = null;
        this.widgetReady = false;
        this.openOnReady = false;

        this.input = selector.querySelector('input[type="radio"]');
        this.placeInput = selector.querySelector('[data-ppl-parcel-shop-place-selector-input]');
        this.result = selector.querySelector('[data-ppl-parcel-shop-place-selector-result]');
        this.country = (selector.dataset.country || 'cz').toUpperCase();
        this.language = selector.dataset.placeSelectorLanguage || 'cs';
        this.apiKey = selector.dataset.pplWidgetApiKey || null;

        this.input.addEventListener('click', () => {
            if (this.apiKey !== null && this.apiKey !== '') {
                this.openWidget();
            } else {
                this.openLegacyMap();
            }
        });

        document.addEventListener('ppl-parcelshop-map', (event) => {
            this.onPlaceSelected(event.detail);
        });
    }

    openWidget() {
        this.ensureLoaderScript();

        if (this.widgetElement === null) {
            this.createWidget();
        }

        if (this.widgetReady === true) {
            this.widgetElement.open();
        } else {
            this.openOnReady = true;
        }
    }

    createWidget() {
        const config = {
            viewMode: 'modal',
            defaultCountry: this.country,
            allowedCountries: [this.country],
            defaultLang: this.language,
        };

        this.widgetElement = document.createElement('ppl-access-point-widget');
        this.widgetElement.setAttribute('api-key', this.apiKey);
        this.widgetElement.setAttribute('config', JSON.stringify(config));

        this.widgetElement.addEventListener('ppl-accesspointwidget-select', (event) => {
            this.onPlaceSelected(event.detail);
        });

        this.widgetElement.addEventListener('ppl-accesspointwidget-ready', () => {
            this.widgetReady = true;
            if (this.openOnReady === true) {
                this.openOnReady = false;
                this.widgetElement.open();
            }
        });

        this.widgetElement.addEventListener('ppl-accesspointwidget-error', (event) => {
            console.error('PPL widget error:', event.detail);
        });

        document.body.appendChild(this.widgetElement);
    }

    ensureLoaderScript() {
        if (document.querySelector(`script[src="${WIDGET_LOADER_URL}"]`) !== null) {
            return;
        }

        const script = document.createElement('script');
        script.src = WIDGET_LOADER_URL;
        document.head.appendChild(script);
    }

    openLegacyMap() {
        this.loadLegacyAssets();
        this.createLegacyModal();
    }

    loadLegacyAssets() {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = LEGACY_CSS_URL;
        link.dataset.pplAsset = true;

        const script = document.createElement('script');
        script.src = LEGACY_JS_URL;
        script.dataset.pplAsset = true;

        document.head.appendChild(link);
        document.head.appendChild(script);
    }

    unloadLegacyAssets() {
        document.querySelectorAll('[data-ppl-asset]').forEach(asset => {
            asset.remove();
        });
    }

    createLegacyModal() {
        this.currentModal = new window.aui.modal({
            title: 'Vyberte místo',
            class: 'ppl-parcelshop-modal',
            body: '<style>' +
                '#ppl-parcelshop-map .accordion-map, #ppl-parcelshop-map .accordion-map--select {\n' +
                'display: none !important;\n' +
                '} ' +
                '.ppl-parcelshop-modal .aui-modal__container-content {\n' +
                'padding: 0 !important;\n' +
                '} ' +
                '</style>' +
                '<div id="ppl-parcelshop-map" data-country="' + this.country.toLowerCase() + '" data-initialfilters="ParcelShop,ParcelBox" style="min-height: 80vh;"></div>',
            type: 'lg',
            onClose: () => { this.unloadLegacyAssets(); }
        });
    }

    onPlaceSelected(detail) {
        this.result.textContent = detail.name;
        this.placeInput.value = detail.code;

        if (this.currentModal !== null) {
            this.currentModal.close();
            this.currentModal = null;
        }
    }

    static init(container) {
        container.querySelectorAll('[data-ppl-parcel-shop-place-selector]').forEach(element => {
            new PplParcelShopSelector(element);
        });
    }

}

naja.addEventListener('init', () => {
    PplParcelShopSelector.init(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
    PplParcelShopSelector.init(event.detail.snippet);
});
